import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  dateFormat,
  selectStyle2,
  toAbsoluteUrl,
} from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { Table3 } from "../../components/table/Table3";
import Select from "react-select";
import { FaEye } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const MySubscription = ({ hideHeader = false }) => {
  if (!hideHeader) ChangeTitle("My Subscription");
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]); // All Data List
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear.toString());

  const yearList = Array.from({ length: currentYear - 1950 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }));

  // My Subscription List Api call
  const viewMySubscriptionList = async (
    year,
    sortOrder,
    sortField,
    limit,
    offset,
  ) => {
    const param = {
      year: year,
      sort: sortOrder,
      sortBy: sortField,
      limit: limit,
      offset: offset,
    };
    var response = await postData(
      "private/user/mysubscription",
      param,
      apiHeader(false),
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const totalRecords = response.data.data.totalRecord;
      setData(data);
      setTotalRecords(totalRecords);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewMySubscriptionList(year, sortOrder, sortField, limit, offset);
  }, [year, sortOrder, sortField, limit, offset]);

  // table columns
  const columns = [
    {
      class: "text-center min-w-[100px]",
      name: <label className="st-head-tr-th-text">Sr. no.</label>,
      cell: (row, rowIndex, baseIndex) => {
        const srNo = baseIndex + rowIndex + 1;
        return (
          <>
            <h1 className="text-center">{srNo}</h1>
          </>
        );
      },
      sortable: false,
      field: "_id",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Product</label>,
      cell: (row) => row.serviceName?.length > 0 ? row.serviceName.map((s) => s.name || s).join(", ") : "-",
      sortable: false,
      field: "",
    },
    // {
    //   class: "min-w-[200px]",
    //   name: <label className="st-head-tr-th-text">Subscriber code</label>,
    //   cell: (row) => "",
    //   sortable: false,
    //   field: "",
    // },
    {
      class: "min-w-[250px]",
      name: <label className="st-head-tr-th-text">Email id</label>,
      cell: (row) => row.email || "-",
      sortable: false,
      field: "email",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Activation</label>,
      cell: (row) => row.startDate || "-",
      sortable: false,
      field: "startDate",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Expriation</label>,

      cell: (row) => row.endDate || "-",
      sortable: false,
      field: "endDate",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Type</label>,
      cell: (row) =>
        row.type == "readyreference"
          ? "Ready Reference"
          : row.type == "advisory"
            ? "Advisory"
            : row.type == "practise"
              ? "Practice"
              : row.type || "-",
      sortable: false,
      field: "type",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Status</label>,

      cell: (row) =>
        row.status == "expire"
          ? "Expire"
          : row.status == "active"
            ? "Active"
            : "-",
      sortable: false,
      field: "status",
    },
    {
      class: "text-center min-w-[100px]",
      name: <label className="st-head-tr-th-text">Action</label>,
      cell: (row) =>
        row.type == "readyreference" || row.type == "practise" ? (
          <div className="flex justify-center">
            <FaEye
              className="cursor-pointer text-[1.2rem]"
              onClick={() => {
                const serviceIds = row.serviceName?.map((s) => s._id) || [];
                if (row.type == "readyreference") {
                  navigate("/product", { state: { serviceIds } });
                } else if (row.type == "practise") {
                 navigate("/mylibrary/practice", { state: { planId: row.planId } });
                }
              }}
            />
          </div>
        ) : (
          <div className="flex justify-center">-</div>
        ),
      sortable: false,
      field: "",
    },
  ];

  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setOffset(0);
  };

  return (
    <>
      <div className={hideHeader ? "w-full" : "w-full p-[5%] min-h-screen bg-yellow"}>
        <div className={hideHeader ? "" : "xxl:container mx-auto"}>
          {!hideHeader && (
            <div className="w-full mb-[5%] md:mb-[2%]">
              <h1 className="hanson text-center mb-[1%] heading">
                My subscription
              </h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
          )}
          <div className="flex justify-end">
            <div className="w-[10rem] mb-10">
              <Select
                name="countryName"
                id="country"
                placeholder="Year"
                className="w-full cs-main"
                isSearchable={true}
                options={yearList}
                value={yearList.find((item) => item.value === year)}
                onChange={(e) => {
                  setYear(e.value);
                }}
                styles={selectStyle2}
              />
            </div>
          </div>
          <Table3
            className="p-[3%] md:p-[1%] mb-5 lg:mb-8"
            columns={columns}
            data={data}
            totalRecords={totalRecords}
            additionalField={""}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
            isAllowAllList={true}
            setLimit={setLimit}
            sortField={sortField}
            sortOrder={sortOrder}
            handleSort={handleSort}
          />
        </div>
      </div>
    </>
  );
};

export default MySubscription;
